export { default } from '@mui/base/Unstable_TrapFocus';